export function notImplementedFunction<T>(): T {
    throw new Error("Function not implemented.");
}
